var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',_vm._b({},'b-form-group',_vm.$attrs,false),[_c('b-form-select',_vm._g(_vm._b({},'b-form-select',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }